import { ImpactCrusherCITypes } from './ImpactCrusherCITypes';

import type { UnitInfoImpactCrusherCIInterface } from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { ImpactCrusherCIUnitInfoDataMapInterface } from './unitInfoData';

export const getMotorFrequency = (
  model: string,
  unitInfoData: ImpactCrusherCIUnitInfoDataMapInterface,
) => {
  return Object.keys(unitInfoData[model].configurations.frequencies);
};

export const getMotorPower = (
  model: string,
  unitInfoData: ImpactCrusherCIUnitInfoDataMapInterface,
) => {
  return unitInfoData[model].configurations.motors.map((x) => x.toString());
};

export const getTipSpeed = (
  model: string,
  motorFrequency: number,
  unitInfoData: ImpactCrusherCIUnitInfoDataMapInterface,
) => {
  return unitInfoData[model].configurations.frequencies[
    motorFrequency
  ].speeds.map((x) => x.toString());
};

export class ImpactCrusherCIConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoImpactCrusherCIInterface {
    const unitInfoData =
      (params?.data as ImpactCrusherCIUnitInfoDataMapInterface | undefined) ??
      {};

    const defaultMotorPower = parseInt(
      getMotorPower(ImpactCrusherCITypes.CI711, unitInfoData)[0],
    );

    return {
      modelName: ImpactCrusherCITypes.CI711,
      setting: 100,
      motorFrequency: parseInt(
        getMotorFrequency(ImpactCrusherCITypes.CI711, unitInfoData)[0],
      ),
      motorPower: defaultMotorPower,
      tipSpeed: parseFloat(
        getTipSpeed(ImpactCrusherCITypes.CI711, 50, unitInfoData)[0],
      ),
      ...BaseUnitConfig.getBaseDefaults(),
      showCustomModel: false,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displaySetting: true,
        displayMotorPower: false,
        displayTipSpeed: true,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const impactCrusherCIConfig = new ImpactCrusherCIConfig();
